class CartItemModal {
	static select = $context => $context.select('.cart-item-modal');

	constructor($modal) {
		this.$modal = $modal;
		this.bindEvents();
	}

	bindEvents() {
		const self = this;



		self.$modal.find('.cart-item-modal__btn-continue').on('click', function () {
			ModalUtil.close();
		});

		$(document).on('shop_cart_add', self.handleCartChange);

		$(document).on('shop_cart_update', self.handleCartChange);

		$(document).on('shop_cart_delete', self.handleCartChange);

		$(document).on('shop_cart_clear', self.handleCartClean);

		self.$modal.find('.cart-item').on('delete_cart_item', function() {
			const $cartItem = $(this);
			self.handleCartDelete($cartItem);
		});

	}

	handleCartChange = (e, response) => {
		const self = this;
		self.changeCount(response.data.count);
		self.changeTotal(response.data.total);

		$(document).trigger('cart_item_change_quantity', self.getQuantity());
	};

	handleCartClean = () => {
		const self = this;
		self.changeCount(0);
		self.changeTotal(0);
	};

	handleCartDelete = ($cartItem) => {
		$(document).trigger('cart_item_deleted');

		$cartItem.closest('.cart-item-modal__items').remove();
		this.$modal.find('.cart-item-modal__title').text('Товар удалён из корзины');
		window.setTimeout(ModalUtil.close, 2000);
	};

	getQuantity = () => {
		const $quantityInput = this.$modal.find('.quantity__input');
		return $quantityInput.val();
	};

	destruct = () => {
		const self = this;
		$(document).off('shop_cart_add', self.handleCartChange);

		$(document).off('shop_cart_update', self.handleCartChange);

		$(document).off('shop_cart_delete', self.handleCartChange);

		$(document).off('shop_cart_clear', self.handleCartClean);
	}

	changeCount = (count) => {
		this.$modal.find('.cart-item-modal__count').text(count);
	}

	changeTotal = (total) => {
		this.$modal.find('.cart-item-modal__total').html(total);
	}

}

export default () => Component(CartItemModal.select, $modal => new CartItemModal($modal));

